import { Action } from 'redux';
import { DeleteUserNotification, DeleteUserNotificationSucceeded } from '../../../app/actions/AppActionTypes';
import { isActionFactory } from '../../../app/actions/isActionFactory';

export interface DeleteUserNotificationAction extends Action {
    notificationId: string;
 }

export interface DeleteUserNotificationSucceededAction extends Action {
    notificationId: string;
}

export function deleteUserNotificationAction(id: string): DeleteUserNotificationAction {
  return {
    type: DeleteUserNotification,
    notificationId: id,
  };
}

export function deleteUserNotificationSucceededAction(id: string): DeleteUserNotificationSucceededAction {
  return {
    type: DeleteUserNotificationSucceeded,
    notificationId: id,
  };
}

export const isDeleteUserNotificationAction = isActionFactory<DeleteUserNotificationAction>(DeleteUserNotification);

export const isDeleteUserNotificationSucceedAction = isActionFactory<DeleteUserNotificationSucceededAction>(DeleteUserNotificationSucceeded);